var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckFull(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.85787 5.85785C9.47521 2.24057 14.4777 0 20 0C25.5223 0 30.5248 2.24057 34.1421 5.85786C37.7594 9.47519 40 14.4777 40 20C40 25.5223 37.7594 30.5248 34.1421 34.1421C30.5248 37.7594 25.5223 40 20 40C14.4777 40 9.4752 37.7594 5.85787 34.1421C2.24058 30.5248 0 25.5223 0 20C0 14.4777 2.24059 9.47519 5.85787 5.85785ZM30.3766 13.2598C31.0866 13.9699 31.0866 15.1211 30.3766 15.8311L19.4675 26.7402C18.7574 27.4502 17.6062 27.4502 16.8962 26.7402L11.4416 21.2856C10.7316 20.5756 10.7316 19.4244 11.4416 18.7144C12.1517 18.0043 13.3029 18.0043 14.0129 18.7144L18.1818 22.8832L27.8053 13.2598C28.5153 12.5498 29.6665 12.5498 30.3766 13.2598Z",
    fill: "url(#paint0_linear_5341_47964)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5341_47964",
    x1: -2.6,
    y1: 20,
    x2: 43.4006,
    y2: 21.0285,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8747F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D60F4"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckFull);
export default __webpack_public_path__ + "static/media/check-full.c880e0eb040a9eb1d0e6a5d2cf9b813c.svg";
export { ForwardRef as ReactComponent };